import { render, staticRenderFns } from "./ContingentBeneficiaries.vue?vue&type=template&id=9b9c711c&scoped=true"
import script from "./ContingentBeneficiaries.vue?vue&type=script&lang=js"
export * from "./ContingentBeneficiaries.vue?vue&type=script&lang=js"
import style0 from "./ContingentBeneficiaries.vue?vue&type=style&index=0&id=9b9c711c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9c711c",
  null
  
)

export default component.exports